{
	"title": "Inloggen",
	"login": {
		"description": "Log in met de passkey op je laptop of telefoon, of met je e-mailadres en wachtwoord.",
		"button": "Inloggen met passkey",
		"busy": "Wachten op je passkey…",
		"or": "of",
		"withPassword": "Inloggen met e-mail en wachtwoord",
		"withPasskey": "Terug naar inloggen met passkey",
		"email": "E-mailadres",
		"password": "Wachtwoord",
		"submit": "Inloggen",
		"forgot": "Wachtwoord vergeten?",
		"failed": "Dit e-mailadres of wachtwoord klopt niet.",
		"botCheck": "Na een paar mislukte pogingen vragen we je eerst deze controle te doen.",
		"locked": "Te veel mislukte pogingen. Inloggen met dit e-mailadres kan weer vanaf {{until}}."
	},
	"enrol": {
		"title": "Inloggen instellen",
		"welcome": "Welkom, {{name}}",
		"description": "Kies hoe je voortaan inlogt op je account ({{email}}). Je kunt later onder \"Mijn account\" ook de andere manier toevoegen.",
		"passkey": {
			"title": "Passkey koppelen (aanbevolen)",
			"description": "Je logt in met je vingerafdruk, je gezicht of de pincode van je laptop of telefoon. Geen wachtwoord om te onthouden.",
			"button": "Passkey koppelen"
		},
		"password": {
			"title": "Wachtwoord instellen",
			"description": "Je logt in met je e-mailadres en een wachtwoord. Op een nieuwe browser vragen we daarna een code uit je mail.",
			"button": "Wachtwoord instellen"
		},
		"button": "Passkey koppelen",
		"busy": "Wachten op je passkey…",
		"invalid": {
			"title": "Deze link werkt niet meer",
			"description": "De link is al gebruikt of verlopen. Vraag een collega om een nieuwe link."
		}
	},
	"problem": {
		"cancelled": "Je hebt het afgebroken, of het duurde te lang. Probeer het opnieuw.",
		"alreadyRegistered": "Deze passkey is al aan je account gekoppeld.",
		"notAllowedHere": "Passkeys werken niet op dit adres.",
		"unsupported": "Deze browser ondersteunt geen passkeys. Gebruik een recente versie van Safari, Chrome, Edge of Firefox.",
		"unknown": "Er ging iets mis. Probeer het opnieuw.",
		"loginFailed": "Inloggen met deze passkey lukte niet. Gebruik een passkey die aan je account gekoppeld is.",
		"rejected": "De passkey kon niet worden gecontroleerd. Probeer het opnieuw.",
		"tooMany": "Te veel pogingen achter elkaar. Wacht een minuut en probeer het dan opnieuw."
	},
	"code": {
		"title": "Vul de code uit je mail in",
		"description": "We hebben een code van 6 cijfers gestuurd naar je e-mailadres. Daarmee bevestig je dat jij het bent. Deze browser onthoudt je daarna 30 dagen.",
		"label": "Code",
		"submit": "Bevestigen",
		"expires": "De code werkt tot {{time}}.",
		"resend": "Stuur een nieuwe code",
		"resendIn": "Een nieuwe code kan over {{seconds}} seconden.",
		"resent": "We hebben een nieuwe code gestuurd.",
		"wrong_one": "Deze code klopt niet. Je hebt nog {{count}} poging.",
		"wrong_other": "Deze code klopt niet. Je hebt nog {{count}} pogingen.",
		"expired": "Deze code werkt niet meer. Log opnieuw in met je wachtwoord.",
		"startOver": "Opnieuw inloggen"
	},
	"password": {
		"new": "Nieuw wachtwoord",
		"newDescription": "Minstens 12 tekens. Een zin van een paar woorden werkt goed.",
		"repeat": "Herhaal het wachtwoord",
		"mismatch": "De twee wachtwoorden zijn niet hetzelfde.",
		"tooShort": "Gebruik minstens 12 tekens.",
		"breached": "Dit wachtwoord staat in een bekend datalek. Kies een ander wachtwoord."
	},
	"reset": {
		"title": "Wachtwoord vergeten",
		"description": "Vul je e-mailadres in. We sturen je een link om een nieuw wachtwoord in te stellen. Heb je alleen passkeys, dan voeg je zo een wachtwoord toe.",
		"submit": "Stuur de link",
		"sent": "Als dit e-mailadres bij een medewerker hoort, staat er nu een link in je mailbox. Die werkt 1 uur.",
		"backToLogin": "Terug naar inloggen",
		"newTitle": "Kies een nieuw wachtwoord",
		"newDescription": "Daarna ben je overal uitgelogd, en vraagt elke browser weer om een code per mail. Je passkeys blijven werken.",
		"save": "Wachtwoord opslaan",
		"done": "Je nieuwe wachtwoord is opgeslagen. Log in om verder te gaan.",
		"invalid": "Deze link werkt niet meer: hij is al gebruikt, verlopen of vervangen door een nieuwere. Vraag een nieuwe link aan."
	},
	"botCheck": {
		"label": "Controle tegen spam",
		"required": "Doe eerst de controle hieronder.",
		"failed": "De controle lukte niet. Probeer het opnieuw.",
		"unavailable": "De controle is nu niet bereikbaar. Probeer het straks opnieuw."
	},
	"help": {
		"trustedBrowser": {
			"title": "Vertrouwde browser",
			"area": "Mijn account",
			"short": "Een browser waarin je na je wachtwoord de code uit je mail invulde. Die browser onthoudt je 30 dagen en vraagt zo lang geen nieuwe code. Met een passkey is er geen code nodig.",
			"warning": "Een nieuw wachtwoord via \"Wachtwoord vergeten?\" logt je overal uit. Elke browser vraagt daarna weer om een code."
		}
	}
}
